<template>
  <base-form :title="title"
             :loading="submitLoading"
             @submit="submitForm">
    <template>
      <fg-input :name="$t('generic.name')"
                :placeholder="$t('generic.name')"
                :label="$t('generic.name')"
                :error="getError($t('generic.name'))"
                v-model="model.name">
      </fg-input>
      <fg-input :name="$t('generic.description')"
                :placeholder="$t('generic.description')"
                :label="$t('generic.description')"
                :error="getError($t('generic.description'))"
                v-model="model.text">
      </fg-input>
    </template>
    <template v-slot:content>
      <div class="-mx-3">
        <dl>
          <div class="bg-gray-50 list-row">
            <dt class="list-row-dt">
              {{$t('generic.name')}}
            </dt>
            <dd class="list-row-dd">
              {{model.name || $t('generic.na')}}
            </dd>
          </div>
          <div class="bg-white list-row">
            <dt class="list-row-dt">
              {{$t('generic.type')}}
            </dt>
            <dd class="list-row-dd">
              {{model.type || $t('generic.na')}}
            </dd>
          </div>
          <div class="bg-gray-50 list-row">
            <dt class="list-row-dt capitalize">
              {{$t('generic.active')}}
            </dt>
            <dd class="list-row-dd">
              <base-switch :value="model.active"
                           @input="onStatusToggle">
              </base-switch>
            </dd>
          </div>

          <div class="bg-white list-row">
            <dt class="list-row-dt">
              {{$t('generic.createdAt')}}
            </dt>
            <dd class="list-row-dd">
              {{$formatDate(model.created_at, 'MMM Do yyyy HH:mm')}}
            </dd>
          </div>
        </dl>
      </div>
    </template>
  </base-form>
</template>
<script>
  import get from 'lodash/get'
  import { Select, Option } from 'element-ui'
  import PaymentTypeService from 'src/services/PaymentTypeService'

  export default {
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      },
      title: String,
      submitLoading: Boolean,
    },
    data () {
      return {
        model: {},
      }
    },
    methods: {
      async submitForm () {
        let isFormValid = await this.$validator.validateAll()
        if (!isFormValid) {
          return
        }
        this.$emit('submit', this.model)
      },
      async onStatusToggle (value) {
        await PaymentTypeService.update(this.$route.params.id, {
          ...this.model,
          active: value
        })
        this.model.active = value
      },
      getFieldValidation(validation) {
        if (validation === 'required') {
          return 'required'
        }
        return ''
      },
    },
    watch: {
      data: {
        immediate: true,
        handler (newVal) {
          if (!newVal) {
            return
          }
          this.model = {
            ...newVal
          }
        }
      }
    }
  }
</script>
<style>
</style>
